<form [formGroup]="form">
  <div style="display: flex; gap: 1rem">
    <div class="flex__child--auto flex-basis-0"></div>

    <mat-form-field class="flex__child--auto flex-basis-0">
      <mat-label>{{ 'total-calculated-amount' | translate }}</mat-label>
      <span matTextPrefix agrNumber class="spacing--padding-half-right">
        {{ currency | agrCurrencySymbol }}
      </span>
      <input
        matInput
        agrNumber
        [enableStepArrows]="false"
        [readonly]="true"
        [step]="0.01"
        [useGrouping]="true"
        formControlName="calculatedAmounts"
        placeholder="{{ 'total-calculated-amount' | translate }}"
        data-test="cost-total__total-calculated-amount"
      />
    </mat-form-field>

    <mat-form-field class="flex__child--auto flex-basis-0">
      <mat-label>{{ 'total-calculated-amount-including-vat' | translate }}</mat-label>
      <span matTextPrefix agrNumber class="spacing--padding-half-right">
        {{ currency | agrCurrencySymbol }}
      </span>
      <input
        matInput
        agrNumber
        [enableStepArrows]="false"
        [readonly]="true"
        [step]="0.01"
        [useGrouping]="true"
        formControlName="calculatedAmountsIncludingVat"
        placeholder="{{ 'total-calculated-amount-including-vat' | translate }}"
        data-test="cost-total__total-calculated-amount-including-vat"
      />
    </mat-form-field>
  </div>
</form>
